export default __webpack_public_path__ + "static/media/kv-m@1.5.72ef3982.jpg";